import React from "react";
import { IWhatsNext } from "../../../src/interfaces";
import ButtonLink from "../../Link";

interface WhatsNextCardProps {
  data: IWhatsNext;
}

function WhatsNextCard({ data }: WhatsNextCardProps) {
  return (
    <div className="rounded w-72 bg-gray-700 text-white">
      <div className="h-40 w-72 bg-black overflow-hidden">
        <img
          src={data.bannerUrl}
          alt="banner"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="flex flex-col gap-4 px-4 py-6">
        <div className="highlightText">{data.title}</div>
        <ButtonLink
          label={data.link?.label}
          href={data.link?.url}
          svgIcon="Arrowright"
          underline
        />
      </div>
    </div>
  );
}

export default WhatsNextCard;
